import React from 'react'
import {Col, Container, Row} from "react-bootstrap";
import {GetText} from "../../context/text.js";

function Footer() {
    let text = GetText();

    return (
        <div className="padTop">
            <div className="topInfoFooter">
                <footer>
                    <Container>
                        <Row className="center-text padTop padBottom">
                            <Col>
                                <p>Copyright &copy;  {text.Footer.title} 2015-{new Date().getFullYear()}. Powered by <a title="yarti7@gmail.com" href="mailto:yarti7@gmail.com">YARTI</a>. </p>
                                <a style={{
                                    color: '#F8F8F8', // Текст невидимий
                                    backgroundColor: '#F8F8F8', // Той самий фон
                                    textDecoration: 'none', // Прибираємо підкреслення
                                    display: 'inline-block', // Забезпечує область для кліку
                                    padding: '0', // Максимально зменшуємо відступи всередині
                                    margin: '0', // Максимально зменшуємо зовнішні відступи
                                    lineHeight: '1' // Мінімізуємо висоту рядка
                                }} href="/allcatalog">map</a>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        </div>

    )
}

export default Footer
